import { Button } from '@/components/_untitled/base/buttons/button';
import { prefixes, useTypedTranslation } from "@/locales";
import { ArrowLeft } from '@untitledui/icons';
import type { KycStepActions } from '../config/kycSteps.config';

interface StepActionsProps extends KycStepActions {
  onBack?: () => void;
}

export function StepActions({
                              canProceed,
                              onPrimaryClick,
                              primaryButtonText,
                              showBack,
                              isLoading,
                              onBack,
                            }: StepActionsProps) {
  const [tGeneral] = useTypedTranslation(prefixes('general'));

  return (
      <>
        <div className="h-px w-full bg-gray-200"/>

        <div className="flex gap-3 p-8">
          { showBack && (
              <Button
                  color="secondary"
                  size="lg"
                  onClick={ onBack }
                  disabled={ isLoading }
                  className="px-14"
                  iconLeading={ <ArrowLeft className="rtl:rotate-180" size={ 15 }/> }
              >
                { tGeneral('back') }
              </Button>
          ) }

          <Button
              color="primary"
              size="lg"
              onClick={ onPrimaryClick }
              isDisabled={ !canProceed || isLoading }
              className="flex-1 bg-brand-950 hover:bg-brand-800 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed disabled:hover:bg-gray-300 text-white"
          >
            { isLoading ? tGeneral('loading') : primaryButtonText }
          </Button>
        </div>
      </>
  );
}
